import { hasFilePathTraversalDots } from 'notable-common';
import { z } from 'zod';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowExportToSftpBlockConfigSchema = z.object({
    fileReference: z.string().min(1, { message: 'File reference is required' }),
    directory: z
        .string()
        .min(1, { message: 'Directory is required' })
        .refine((value) => !value.startsWith('/'), {
        message: 'Directory must be a relative path (no leading /)',
    })
        .refine((value) => !value.includes('\\'), {
        message: 'Directory must use forward slashes only',
    })
        .refine((value) => !hasFilePathTraversalDots(value), {
        message: 'Directory must not contain `.` or `..` segments',
    }),
    filename: z
        .string()
        .min(1, { message: 'Filename is required' })
        .refine((value) => !value.includes('/') && !value.includes('\\'), {
        message: 'Filename must not contain path separators',
    })
        .refine((value) => !hasFilePathTraversalDots(value), {
        message: 'Filename must not be `.` or `..`',
    }),
    onCollision: z.enum(['Overwrite', 'Error']).default('Overwrite'),
});
export const FlowExportToSftpBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.ExportToSftp),
    config: FlowExportToSftpBlockConfigSchema,
});
//# sourceMappingURL=config.js.map